// @ts-nocheck
import { ComplianceRequestType } from '../constants/compliance';
import Events from '../constants/events';
import { siteApi } from '../services';
import { handleError } from '../utilities';
import store from '../store';

export default new Proxy(
  {
    events: Object.fromEntries(
      Object.entries(Events).filter(([, value]) =>
        value.startsWith('concord-compliance'),
      ),
    ),
    types: ComplianceRequestType,
    onComplianceRequestsChanged: (callback) =>
      window.addEventListener(Events.ComplianceRequestsChanged, callback),
    onComplianceRequestsLoaded: (callback) =>
      window.addEventListener(Events.ComplianceRequestsLoaded, callback),
    onComplianceRequestsLoading: (callback) =>
      window.addEventListener(Events.ComplianceRequestsLoading, callback),

    submitComplianceRequest: async ({
      request,
      userEmail,
      userPhoneNumber,
      userFirstName,
      userLastName,
      requestDetails,
    }) => {
      try {
        const data = await siteApi.postComplianceRequest({
          captureUrl: window.location.href,
          userEmail,
          userPhoneNumber,
          userFirstName,
          userLastName,
          request,
          requestDetails,
        });
        // Force refresh after submitting a new compliance request
        await store.complianceRequests.refreshData({ forceRefresh: true });
        return data;
      } catch (err) {
        handleError(err);
        throw err;
      }
    },
    verifyComplianceRequest: async (complianceRequestId, verificationCode) => {
      try {
        await siteApi.verifyComplianceRequest(complianceRequestId, {
          verificationCode,
        });
        // Force refresh after verifying a compliance request
        await store.complianceRequests.refreshData({ forceRefresh: true });
        return true;
      } catch (err) {
        handleError(err);
        throw err;
      }
    },
    sendComplianceRequestDetail: async (complianceRequestId, projectId) => {
      try {
        await siteApi.sendComplianceRequestDetail(complianceRequestId, {
          projectId,
        });
        // Force refresh after requesting compliance request details
        await store.complianceRequests.refreshData({ forceRefresh: true });
        return true;
      } catch (err) {
        handleError(err);
        throw err;
      }
    },
  },
  {
    get: (obj, prop) => {
      if (prop === 'complianceRequests') {
        return store.complianceRequests.complianceRequests;
      }
      return Reflect.get(obj, prop);
    },
    set: () => false,
  },
);
